import React, { Component } from 'react';
import './Object.css';
import { Row, Col, Accordion, Card } from 'react-bootstrap'
import { WebMapView } from '../WebMapView';

import { CustomToggle } from '../custom/CustomToggle'
import { ObjectListForLinks } from '../ObjectListForLinks';

import { FullDescModal } from './FullDescModal';

import { Gallery } from './Gallery';
import { DocObjectListForLinksTable } from '../DocObjectListForLinksTable';
import { EventObjectListForLinksTable } from '../EventObjectListForLinksTable';
import Avatar from 'react-avatar';
import { Footer } from '../Footer';
import ReactTooltip from "react-tooltip";
import PulseLoader from "react-spinners/PulseLoader";

import { authHeader, handleResponse } from '../../_helpers';
import { authenticationService } from '../../_services';

import { AddToCollection } from '../AddToCollection';
import { Share } from '../Share';

export class StoneEngraveObject extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentUser: null,
            isAdmin: false,
            favorite: false,
            stoneengrave: {},
            objectID: null,
            objToZoom: null,
            fullScreeenIcon: "esri-icon-zoom-out-fixed",
            mapClass: '',
            maptype: '',
            loading: true
        };

        this.fullScreenMode = this.fullScreenMode.bind(this)
    }
    componentDidMount() {
        var el = document.querySelector('.searchComponentButton');
        el.textContent = "ქვაზე კვეთილობა";

        authenticationService.currentUser.subscribe(x => this.setState({
            currentUser: x, isAdmin: x && x.role === "Admin"
        }));
        this.loadPage();
    }

    async loadPage() {
        const params = new URLSearchParams(window.location.search);
        const id = parseInt(params.get('id'));
        if (id !== null) {
            var type = `api/StoneEngrave/GetStoneEngraveObject?id=${id}`;

            if (this.state.currentUser != null) {
                const requestOptions = {
                    method: 'GET',
                    headers: authHeader()
                };
                const response = await fetch(type, requestOptions);
                const data = await response.json();
                this.setState({ stoneengrave: data, loading: false, favorite: data.isFavorite, maptype: data.curLocId !== "" ? data.curLocType : data.oldLocType,  objectID: data.curLocId });


            }
            else {
                const response = await fetch(type);
                const data = await response.json();
                this.setState({ stoneengrave: data, loading: false, favorite: data.isFavorite, maptype: data.curLocId !== "" ? data.curLocType : data.oldLocType, objectID: data.curLocId});

            }
        }
    }

    toogleFullDesc() {
        if (document.getElementsByClassName('DescTextFull')[0].classList.contains('displayNone')) {
            document.getElementsByClassName('DescTextFull')[0].classList.remove('displayNone');
            document.getElementsByClassName('DescText')[0].classList.add('displayNone');
        }
        else {
            document.getElementsByClassName('DescTextFull')[0].classList.add('displayNone');
            document.getElementsByClassName('DescText')[0].classList.remove('displayNone');
        }

    }


    toogleMapActiveLink(val) {
        document.getElementsByClassName('mapLink')[0].classList.remove('active');
        document.getElementsByClassName('mapLink')[1].classList.remove('active');
        document.getElementsByClassName('mapLink')[val].classList.add('active');

        if (val === 0)
            this.setState({
                "maptype": this.state.wallart.curLocType, "mapObjectID": this.state.wallart.curLocId
            })
        else this.setState({
            "maptype": this.state.wallart.oldLocType, "mapObjectID": this.state.wallart.oldLocId
        })


        document.getElementsByClassName('mapCoord')[0].classList.add('displayNone');
        document.getElementsByClassName('mapCoord')[1].classList.add('displayNone');
        document.getElementsByClassName('mapCoord')[val].classList.remove('displayNone');
    }
    static displayName = StoneEngraveObject.name;

    addToFavorite(id) {
        if (this.state.favorite === false) {
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };

            fetch(`api/Users/AddToFvorite?folderID=0&objectType=stoneengrave&objectID=${id}`, requestOptions)
                .then(data => {
                    this.setState({ favorite: true });
                });
        }
        else {
            var result = window.confirm("გსურთ წაშლა?");
            if (result) {
                const requestOptions = {
                    method: 'GET',
                    headers: authHeader()
                };
                return fetch(`api/Users/DeleteFromFvorite?objectType=stoneengrave&objectID=${id}`, requestOptions)
                    .then(data => {
                        this.setState({ favorite: false });
                    });
            }
        }
    }
    hadleFavoriteStatus(value) {
        this.setState({ favorite: value });
    }

    fullScreenMode() {
        if (this.state.mapClass === '') {
            this.setState({ fullScreeenIcon: 'esri-icon-zoom-in-fixed', mapClass: 'objectFullScreentMap', objectID: null, objToZoom: this.state.stoneengrave.curLocId })
        }
        else {

            document.getElementById('toolbarDiv').classList.add('displayNone');
            document.getElementById('menuDiv').classList.add('displayNone')
            this.setState({ fullScreeenIcon: 'esri-icon-zoom-out-fixed', mapClass: '', objectID: this.state.stoneengrave.curLocId, objToZoom: null })
        }
    }

    render() {
        const stoneengrave = this.state.stoneengrave;

        window.FB = null;
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            // if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/ka_GE/sdk.js#xfbml=1&autoLogAppEvents=1&version=v8.0&appId=1607074352807965";
            js.nonce = "q90Xb87m";

            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));


        let images = [];
        if (stoneengrave.photoIds != null) {
            stoneengrave.photoIds.map(item =>
                images.push({
                    original: item,
                    thumbnail: item
                })
            );
        }
        else {
            images.push({
                original: '/stoneengrave.svg',
                thumbnail: '/stoneengrave.svg'
            });
        }



        return (
            <div className="immObjDiv">
                {stoneengrave && stoneengrave.id > 0 ?
                    <div>
                        <div className="containerDiv">
                            <Row className="rowPadding">
                                <Col md={5}>
                                    <Gallery photo={stoneengrave.photoIds} video={stoneengrave.videoIds} vid3D={stoneengrave._3dobjects} mainphoto={stoneengrave.photoAddress} type="stoneengrave" authors={stoneengrave.docAuthors} />
                                </Col>
                                <Col md={7}>

                                    <div className="ObjectType">ქვაზე კვეთილობა</div>
                                    <div className="ObjectMainHeader" style={{ marginBottom: '20px' }}>
                                       
                                        <span className="ObjectMainHeaderSpan">{stoneengrave.objectName} - #{stoneengrave.id}</span>
                                        <Share header="გაზიარება" customClass="objectShare" />
                                        {this.state.currentUser && this.state.isAdmin === false &&
                                            //<div style={{ float: 'right', cursor: 'pointer' }}><img width="20" alt="" src={this.state.favorite ? "/images/heartfill.svg" : "/images/heart.svg"} style={{ marginRight: '10px' }} onClick={() => this.addToFavorite(immovable.id)} />{' '}</div>
                                            <AddToCollection favorite={this.state.favorite} objID={stoneengrave.id} setStatus={this.hadleFavoriteStatus.bind(this)}></AddToCollection>
                                        }
                                    </div>

                                    <div><span className="headerText">ისტორიული/კულტურული პერიოდი: </span>
                                        <ul className="periodList">
                                            {
                                                stoneengrave.period.split(';').map((item, i) => {
                                                    return <li key={i}>{item}</li>;
                                                })
                                            }</ul></div>
                                    <div><span className="headerText">თარიღი: </span>{stoneengrave.date}</div>

                                    <p style={{ borderBottom: '1px solid #ECECEC', marginTop: '20px' }} />
                                    <div className="DescText">
                                        {stoneengrave.description}
                                        <div onClick={this.toogleFullDesc} className="toggleFullDesc">
                                            <svg className="bi bi-chevron-double-down" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" d="M1.646 6.646a.5.5 0 01.708 0L8 12.293l5.646-5.647a.5.5 0 01.708.708l-6 6a.5.5 0 01-.708 0l-6-6a.5.5 0 010-.708z" clipRule="evenodd" />
                                                <path fillRule="evenodd" d="M1.646 2.646a.5.5 0 01.708 0L8 8.293l5.646-5.647a.5.5 0 01.708.708l-6 6a.5.5 0 01-.708 0l-6-6a.5.5 0 010-.708z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="DescTextFull displayNone">{stoneengrave.descriptionFull}
                                        <div onClick={this.toogleFullDesc} style={{ textAlign: "center", padding: "20px" }}>
                                            <svg className="bi bi-chevron-double-up" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" d="M7.646 2.646a.5.5 0 01.708 0l6 6a.5.5 0 01-.708.708L8 3.707 2.354 9.354a.5.5 0 11-.708-.708l6-6z" clipRule="evenodd" />
                                                <path fillRule="evenodd" d="M7.646 6.646a.5.5 0 01.708 0l6 6a.5.5 0 01-.708.708L8 7.707l-5.646 5.647a.5.5 0 01-.708-.708l6-6z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div style={{ display: "inline-flex" }}>
                                        <FullDescModal className="FullDescModal" buttonDesc="დეტალური აღწერა" objname={stoneengrave.objectName} >
                                            <div className="PopupHeader">მოკლე დახასიათება</div>
                                            {stoneengrave.descriptionFull}
                                        </FullDescModal>
                                    </div>
                                </Col>
                            </Row>
                            <div className="ObjectHeaderNoTop" style={{ marginLeft: '35px', marginTop: '20px' }}>ადგილმდებარეობა</div>
                            <Row style={{ padding: '20px 20px 0 20px', width: '100%' }} className="ObjectMapRow">
                                <Col md={5}>
                                    <div style={{ display: 'inline-flex', width: '100%' }}>
                                        <img style={{ margin: '5px 20px 0 0', width: '18px', height: '22px' }} alt="" src="/images/map-pin.svg" />{' '}
                                        <div>
                                            <div>ამჟამინდელი:</div>
                                            {stoneengrave.country !== '' ? <div>ქვეყანა: <span className="headerText">{stoneengrave.country}</span></div> : <></>}
                                            {stoneengrave.region !== '' ? <div>რეგიონი: <span className="headerText">{stoneengrave.region}</span></div> : <></>}
                                            {stoneengrave.municipality !== '' ? <div>მუნიციპალიტეტი: <span className="headerText">{stoneengrave.municipality}</span></div> : <></>}
                                            {stoneengrave.settlement !== '' ? <div>დასახლებული პუნქტი: <span className="headerText">{stoneengrave.settlement}</span></div> : <></>}
                                            {stoneengrave.street !== '' ? <div>მისამართი: <span className="headerText">{stoneengrave.street}</span></div> : <></>}
                                        </div>
                                    </div>

                                    {(stoneengrave.oldcountry !== '' || stoneengrave.oldregion !== '' || stoneengrave.oldmunicipality !== '' || stoneengrave.oldsettlement !== '' || stoneengrave.oldstreet !== '') ?
                                        <div style={{ display: 'inline-flex', marginTop: '20px', width: '100%' }}>
                                            <img style={{ margin: '5px 20px 0 0', width: '18px', height: '22px' }} alt="" src="/images/map-pin.svg" />{' '}
                                            <div>
                                                <div>წარმომავლობა:</div>
                                                {stoneengrave.oldcountry !== '' ? <div>ქვეყანა: <span className="headerText">{stoneengrave.oldcountry}</span></div> : <></>}
                                                {stoneengrave.oldregion !== '' ? <div>რეგიონი: <span className="headerText">{stoneengrave.oldregion}</span></div> : <></>}
                                                {stoneengrave.oldmunicipality !== '' ? <div>მუნიციპალიტეტი: <span className="headerText">{stoneengrave.oldmunicipality}</span></div> : <></>}
                                                {stoneengrave.oldsettlement !== '' ? <div>დასახლებული პუნქტი: <span className="headerText">{stoneengrave.oldsettlement}</span></div> : <></>}
                                                {stoneengrave.oldstreet !== '' ? <div>მისამართი: <span className="headerText">{stoneengrave.oldstreet}</span></div> : <></>}
                                            </div>
                                        </div>
                                        : <></>
                                    }
                                </Col>
                                <Col md={7} style={{ minHeight: '300px' }} className="ObjectMap movableMap">
                                    <div style={{ display: "inline-block", margin: '0 10px 10px 0px' }}>
                                        <button className={stoneengrave.curLocId !== "" ? 'mapLink active' : 'mapLink not-active'} onClick={() => this.toogleMapActiveLink(0)} disabled={(stoneengrave.curLocId === "")}>ამჟამინდელი</button>
                                        <button className={stoneengrave.curLocId !== "" ? 'mapLink' : stoneengrave.oldLocId !== "" ? 'mapLink active' : 'mapLink not-active'} onClick={() => this.toogleMapActiveLink(1)} style={{ marginLeft: "20px" }} disabled={(stoneengrave.oldLocId === "")}>წარმომავლობა</button>
                                    </div>
                                    <WebMapView type={this.state.maptype} objectID={this.state.objectID} objToZoom={this.state.objToZoom} right="30px" fullScreeenIcon={this.state.fullScreeenIcon} fullClick={this.fullScreenMode.bind(this)} mapClass={this.state.mapClass} />

                                </Col>
                            </Row>
                            <Row>
                                <Col md={5}>

                                </Col>
                                <Col md={7}>

                                    <Row className={stoneengrave.curLocId !== "" ? 'mapCoord' : 'mapCoord displayNone'}>
                                        <Col md={5} style={{ marginBottom: '20px' }}>
                                            <div className="icon-waves">
                                                სიმაღლე ზღვის დონიდან: {stoneengrave.elevetion}მ.
                                        </div>
                                        </Col>
                                        <Col md={6} style={{ marginBottom: '20px' }}>
                                            <div className="icon-direction-outline">კოორდინატები {stoneengrave.sizuste === 'სწორია' ? <img style={{ width: '17px', height: '17px' }} alt="" src="/images/OK.svg" /> : <></>}
                                            </div>
                                            {stoneengrave.sizuste === 'სწორია' ?
                                                <div>
                                                    <span className="headerText">X: </span>{stoneengrave.y}
                                                    <span className="headerText"> Y: </span>{stoneengrave.x}
                                                </div> :
                                                <div>
                                                    კოორდინატები დასაზუსტებელია
                                                </div>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className={stoneengrave.curLocId !== "" ? 'mapCoord displayNone' : 'mapCoord'}>
                                        <Col md={5} style={{ marginBottom: '20px' }}>
                                            <div className="icon-waves">
                                                სიმაღლე ზღვის დონიდან: {stoneengrave.elevetionOld}მ.
                                        </div>
                                        </Col>
                                        <Col md={6} style={{ marginBottom: '20px' }}>
                                            <div className="icon-direction-outline">კოორდინატები {stoneengrave.sizusteOld === 'სწორია' ? <img style={{ width: '17px', height: '17px' }} alt="" src="/images/OK.svg" /> : <></>}
                                            </div>
                                            {stoneengrave.sizusteOld === 'სწორია' ?
                                                <div>
                                                    <span className="headerText">X: </span>{stoneengrave.xOld}
                                                    <span className="headerText"> Y: </span>{stoneengrave.yOld}
                                                </div> :
                                                <div>
                                                    კოორდინატები დასაზუსტებელია
                                                </div>
                                            }
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                        </div>

                        <div className="containerDiv">
                            {stoneengrave.shemadgeneliLinkExist ?
                                <Row className="accardionPadding">
                                    <Accordion defaultActiveKey="1">
                                        <Card>
                                            <Card.Header className="TogglePanelHeader">
                                                <CustomToggle eventKey="1" isOpen="true"><span className="headerText">ქვაზე კვეთილობის შემადგენელი კვეთილობა</span></CustomToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="1">
                                                <Card.Body className="accardionBodyPadding">
                                                    <ObjectListForLinks objID={stoneengrave.id} type="stoneengraveMembership" objType="stoneengrave" curobjID="0" objName={stoneengrave.objectName} />
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                </Row>
                                : <></>
                            }

                        </div>
                        {
                            stoneengrave.linksDisplay ? <p style={{ borderBottom: '1px solid #ECECEC', marginTop: '80px' }} /> : <></>

                        }
                        <div className="containerDiv">
                            <div className="accardionPadding ObjectHeaderNoTop">{stoneengrave.linksDisplay ? 'დაკავშირებული კომპონენტები' : ''}</div>

                            {stoneengrave.immovableLinkExist ?
                                <Row className="accardionPadding">
                                    <Accordion defaultActiveKey="0">
                                        <Card>
                                            <Card.Header className="TogglePanelHeader">
                                                <CustomToggle eventKey="1"><span className="headerText">უძრავი ძეგლი/ობიექტი {stoneengrave.immovableLinksCount}</span></CustomToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="1">
                                                <Card.Body className="accardionBodyPadding">
                                                    <ObjectListForLinks objID={stoneengrave.id} type="immovable" objType="stoneengrave" idList={stoneengrave.immovableLinks}
                                                        objName={stoneengrave.objectName} />
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                </Row>
                                : <></>
                            }
                            {
                                stoneengrave.eventLinkExist ?
                                    <Row className="accardionPadding">
                                        <Accordion defaultActiveKey="0">
                                            <Card>
                                                <Card.Header className="TogglePanelHeader">
                                                    <CustomToggle eventKey="1"><span className="headerText">ქმედება {stoneengrave.eventLinksCount}</span></CustomToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body className="accardionBodyPadding">
                                                        {
                                                            <EventObjectListForLinksTable caption={{ type: "ქმედების ტიპი", docNum: "ნომერი" }} objID={stoneengrave.id} type="event"
                                                                objType="stoneengrave" idList={stoneengrave.eventLinks} objName={stoneengrave.objectName} />
                                                        }
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                    </Row>
                                    : <></>
                            }
                            {stoneengrave.docLinkExist ?
                                <Row className="accardionPadding">
                                    <Accordion defaultActiveKey="0">
                                        <Card>
                                            <Card.Header className="TogglePanelHeader">
                                                <CustomToggle eventKey="1"><span className="headerText">დოკუმენტაცია</span></CustomToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="1">
                                                <Card.Body className="accardionBodyPadding">
                                                    <DocObjectListForLinksTable caption={{ type: "დოკუმენტის ტიპი", docNum: "ავტორი" }} objID={stoneengrave.id} type="document" objType="stoneengrave" idList={stoneengrave.docLinks} objName={stoneengrave.objectName} />
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                </Row>
                                : <></>
                            }
                        </div>

                        <Footer>
                            <div className="containerDiv" style={{ paddingTop: '40px', paddingLeft: '20px' }}>
                                <Row >
                                    <Col md={5}>
                                        <div style={{ fontFamily: 'HelveticaBold', fontSize: '16px' }}>ინფორმაციის შემდგენელი</div>
                                        <div style={{ marginBottom: '20px' }}>თარიღი: <span className="headerText">{stoneengrave.cardCreationDate}</span></div>
                                        <div style={{ display: 'inline-flex' }}>
                                            <Avatar title={stoneengrave.cardCreator[0].name} src={stoneengrave.cardCreator[0].photo} size={50} round="50px" />
                                            <span className="avatarText" data-tip data-for="allAuthors">{stoneengrave.cardCreator.length > 1 ? `${stoneengrave.cardCreator[0].name} \n\r(+ ${stoneengrave.cardCreator.length - 1} ავტორი)`
                                                : stoneengrave.cardCreator[0].name}</span>
                                        </div>
                                        {stoneengrave.cardCreator.length > 1 ?
                                            <ReactTooltip className="customZIndex" id="allAuthors" effect='solid' backgroundColor="#FFFFFF" textColor="#000000" place="bottom" border={true} offset={{ top: 70, left: -35 }}>
                                                <span>
                                                    <ul className="periodList">{
                                                        stoneengrave.cardCreator.map((item, i) => {
                                                            return <div style={{ marginTop: '5px' }} key={i}> <Avatar title={item.name} src={item.photo} size={30} round="30px" />
                                                                <span style={{ marginLeft: '10px' }}>{item.name}</span></div>
                                                                ;
                                                        })
                                                    }</ul>
                                                </span>
                                            </ReactTooltip>
                                            : <></>
                                        }
                                    </Col>
                                    <Col md={7}>
                                        <p style={{ borderBottom: '1px solid #ECECEC' }} className="facebookCOmmentP" />
                                        <div className="fb-comments" data-href={window.location.href} data-numposts="5" data-width="" data-mobile="true"></div>
                                    </Col>
                                </Row>
                            </div>
                        </Footer>
                    </div>
                    : <div style={{
                        marginLeft: 'auto', marginRight: 'auto', width: '100%', padding: '50px', textAlign: 'center'
                    }}>
                        <PulseLoader
                            color={"#E57959"}
                            loading={true}
                        />
                    </div>
                }
            </div>
        );
    }

}